import styled from "styled-components";

export const Wrapper = styled.div`
  width: 100%;
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
